module.exports = __webpack_public_path__ + "static/img/pic22.bb6ee7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic22.png
// module id = 0OXU
// module chunks = 0